import { Moment } from 'moment';
import { BookingQuotationProduct } from './booking-quotation-product';
import { Currency } from './currency';
import Decimal from 'decimal.js';

export class BookingQuotation {
    constructor(
        public description: string,
        public comment: string,
        public productList: BookingQuotationProduct[],
        public baseCurrency: Currency,
        public secondCurrency: Currency,
        public quotationDate: Moment | null,
        public dueDate: Moment | null,
        public deposit: Decimal,
        public priceIncludes: string,
        public priceNotIncludes: string,
        public id?: number
    ){}
}
